import { FC } from 'react';
import cx from 'classnames';
import { externalLinks } from '@/config';
import { useOpenChat } from '@/hooks';

import iconTelegramColor from '@/assets/images/socials/logo-telegram-color.svg';
import iconMessengerColor from '@/assets/images/socials/logo-messenger-color.svg';

import styles from './Support.module.sass';

interface SupportProps {
  className?: string;
}
const Support: FC<SupportProps> = (props) => {
  const { className } = props;
  const { handleOpenChat } = useOpenChat();

  const theClassName = cx(styles.support, !!className && className);
  return (
    <div className={theClassName}>
      <button type="button" className={styles.button} onClick={handleOpenChat}>
        <img src={iconTelegramColor} alt="Support" />
      </button>
      {false && (
        <a
          href={externalLinks.MESSENGER_SUPPORT_URL}
          rel="noopener noreferrer"
          target="_blank"
        >
          <img src={iconMessengerColor} alt="Messenger" />
        </a>
      )}
    </div>
  );
};

export default Support;
